module.exports = __webpack_public_path__ + "img/svg - only book.79cf4a27.svg";